<template>
  <div>
    <el-button v-for="item in buttonList" v-bind:key="item.id" :type="item.buttonType" @click="callFunc(item)">
      {{ item.name }}</el-button>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "Toolbar",
  data() {
    return {
      searchVal: "", //双向绑定搜索内容
    };
  },
  props: ["buttonList", "funcParams"], //接受父组件传值
  created() {
  },
  methods: {
    callFunc(item) {
      // item.search = this.searchVal;
      if (this.funcParams) {
        item.funcParams = this.funcParams;
      }
      this.$emit("callFunction", item); //将值传给父组件
    }
  }
};
</script>
